<template>
  <section class="main">
    <TheHeader />
    <div class="container pt-5">
      <div class="row">
        <div class="col">
          <h3>Relatórios</h3>
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <nav aria-label="breadcrumb" id="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Relatórios
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="row pt-5">
        <div class="col-md-12">
          <div class="row">
            <transition mode="out-in">
              <router-view></router-view>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <TheFooter />
  </section>
</template>
<script>
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
export default {
  name: "Relatorios",
  components: {
    TheHeader,
    TheFooter,
  },
  mounted() {
    this.$store.dispatch("getUserData");
  },
};
</script>

<style lang="scss" scoped>
@media screen and(max-width: 900px) {
  #v-pills-tab {
    display: flex;
    flex-direction: row !important;
    justify-content: space-between;
    margin-bottom: 1rem;
    a {
      width: 22%;
      text-align: center;
      justify-content: center;
      align-items: center;
      span {
        display: none;
      }
    }
  }
}
</style>
